import CONTEXT from '@aureus/cov-context';

const defaultContext = CONTEXT.ROUNDOUT;

export default defaultContext;
